import { RouteObject } from 'react-router-dom';

import { Subscription } from './Subscription';
import { SubscriptionError } from './SubscriptionError';

export const subscriptionRoute: RouteObject = {
  path: '/subscription',
  children: [
    { index: true, element: <Subscription /> },
    { path: 'error', element: <SubscriptionError /> },
  ],
};
